import {useState} from "react"
import {createModel} from "hox"

function PreInput() {
    const [value, setValue] = useState(50)

    const init = () => {
        setValue(50)
    }

    const changeValue = (val: number) => {
        setValue(val)
    }
    return {
        value: value,
        init,
        changeValue,
    }
}

export default createModel(PreInput)
